import React, { useState } from 'react';
import { Play, X, MessageSquare } from 'lucide-react';

const PresidentMessageModern: React.FC = () => {
    const [showVideo, setShowVideo] = useState(false);

    // Données statiques du président
    const presidentData = {
        name: "Brice Clotaire Oligui Nguema",
        title: "Bâtisseur Fondateur de l'Union Démocratique des Bâtisseurs",
        image: "/images/president0.jpg",
        message: "Chers compatriotes gabonais, en ce jour solennel où nous célébrons l'aurore d'un nouveau départ démocratique, je m'engage à servir, protéger et unir tous les Gabonais. Le 12 avril dernier, vous avez exprimé votre souveraineté à 94,85%, choisissant d'ouvrir un nouveau chapitre de notre histoire. Cette Vème République que nous appelons de tous nos vœux exige la fin de l'impunité, de la corruption, et l'établissement d'un véritable État de droit.",
        signature: "/images/signature.png",
        videoUrl: null // Peut être défini si une vidéo est disponible
    };

    return (
        <section id="president-message" className="py-0 bg-gray-50">
            <div className="grid lg:grid-cols-2">
                {/* Colonne gauche - Image 50% */}
                <div className="relative h-96 lg:h-auto lg:min-h-screen">
                    <div className="absolute inset-0">
                        <img
                            src={presidentData.image}
                            alt={presidentData.name}
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    </div>

                    {/* Info overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                        <h3 className="text-2xl font-light mb-1">{presidentData.name}</h3>
                        <p className="text-white/80 font-light">{presidentData.title}</p>

                        {presidentData.videoUrl && (
                            <button
                                onClick={() => setShowVideo(true)}
                                className="mt-4 flex items-center space-x-2 text-white/80 hover:text-white transition-colors"
                            >
                                <Play className="w-5 h-5" />
                                <span className="text-sm">Voir le message vidéo</span>
                            </button>
                        )}
                    </div>
                </div>

                {/* Colonne droite - Contenu 50% */}
                <div className="bg-white">
                    <div className="p-8 lg:p-16 max-w-2xl mx-auto">
                        {/* Header */}
                        <div className="mb-12">
                            <div className="flex items-center space-x-2 mb-6">
                                <MessageSquare className="w-5 h-5 text-primary-blue" />
                                <span className="text-primary-blue text-sm uppercase tracking-wider">Message d'investiture</span>
                            </div>
                            <h2 className="text-4xl lg:text-5xl font-light text-gray-900 leading-tight">
                                La renaissance
                                <span className="block text-primary-green">d'une nation</span>
                            </h2>
                        </div>

                        {/* Message */}
                        <div className="space-y-6">
                            <p className="text-lg text-gray-700 font-light leading-relaxed">
                                {presidentData.message}
                            </p>

                            {/* Vision points */}
                            <div className="grid grid-cols-2 gap-8 py-8 border-y border-gray-100">
                                <div>
                                    <div className="text-2xl font-light text-primary-blue mb-2">01</div>
                                    <h4 className="font-normal text-gray-900 mb-1">État de droit</h4>
                                    <p className="text-sm text-gray-500">Justice et fin de l'impunité</p>
                                </div>
                                <div>
                                    <div className="text-2xl font-light text-primary-green mb-2">02</div>
                                    <h4 className="font-normal text-gray-900 mb-1">Développement</h4>
                                    <p className="text-sm text-gray-500">Infrastructures et économie</p>
                                </div>
                                <div>
                                    <div className="text-2xl font-light text-primary-blue mb-2">03</div>
                                    <h4 className="font-normal text-gray-900 mb-1">Unité nationale</h4>
                                    <p className="text-sm text-gray-500">Gabon uni et solidaire</p>
                                </div>
                                <div>
                                    <div className="text-2xl font-light text-primary-green mb-2">04</div>
                                    <h4 className="font-normal text-gray-900 mb-1">Relations internationales</h4>
                                    <p className="text-sm text-gray-500">Retour dans la communauté africaine</p>
                                </div>
                            </div>

                            {/* Quote */}
                            <blockquote className="pl-6 border-l-2 border-primary-blue">
                                <p className="text-xl font-light text-gray-800 italic">
                                    "Ensemble, avec le travail, la discipline, l'effort et la foi en notre pays,
                                    nous déplacerons des montagnes pour bâtir un Gabon nouveau."
                                </p>
                            </blockquote>

                            {/* CTA */}
                            <div className="pt-8">
                                <button
                                    onClick={() => document.getElementById('adhesion')?.scrollIntoView({ behavior: 'smooth' })}
                                    className="bg-primary-blue text-white px-8 py-3 hover:bg-primary-green transition-colors"
                                >
                                    Participer à la Vème République
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Vidéo */}
            {showVideo && presidentData.videoUrl && (
                <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
                    <div className="relative bg-black max-w-4xl w-full">
                        <button
                            onClick={() => setShowVideo(false)}
                            className="absolute -top-12 right-0 text-white hover:text-gray-300"
                        >
                            <X className="w-8 h-8" />
                        </button>
                        <div className="aspect-video">
                            <iframe
                                src={presidentData.videoUrl}
                                className="w-full h-full"
                                allowFullScreen
                                title="Message du Président"
                            />
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default PresidentMessageModern;
